import axiosInstance from "../utilities/axiosSetup";

export const list_agents = async () => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/list-agents",
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const update_agent_special_id = async (agent_id, agent_special_id) => {
  try {
    const { data } = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/update-agent-special-id",
      { agent_id, agent_special_id },
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};